import { Injectable } from '@angular/core';
import { WorkshopDefectPart } from '../models/workshop-defect-part.model';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class WorkshopDefectPartService {

  private _endpoint: string = environment.api.endpoint;

  constructor(private httpClient: HttpClient) { }

  getForDefect(workshopDefectId: number): Observable<WorkshopDefectPart[]> {
    return this.httpClient.get(this._endpoint + 'workshop-defect-part?workshopDefectId=' + workshopDefectId)
    .pipe(map((data) => {
      return <WorkshopDefectPart[]>data;
    }));
  }

  assignPart(workshopDefectId: number, productId: number, qty: number): Observable<WorkshopDefectPart> {
    return this.httpClient.post(this._endpoint + 'workshop-defect-part',
    JSON.stringify({ workshopDefectId, productId, qty }),
    {headers: {'Content-Type': 'application/json'}}).pipe(map((data) => {
      return <WorkshopDefectPart>data;
    }));
  }

  removePart(id: number): Observable<any> {
    return this.httpClient.delete(this._endpoint + 'workshop-defect-part/' + id);
  }
}
